export default "__VITE_ASSET__29c7ece6__"